import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { Events, MessageService } from 'src/app/core/services';
import { environment } from 'src/environments/environment';
import { HistoryNotesService } from '../history-notes.service';

@Component({
	selector: 'crm-history-note-edit-modal',
	templateUrl: './history-note-edit-modal.component.html'
})
export class HistoryNoteEditModalComponent {
	@Output() handleExitClick: EventEmitter<void> = new EventEmitter<void>();

	private logMessage: string = this.historyNotesService.selectedHistoryNote.LogMessage;

	constructor(public historyNotesService: HistoryNotesService, private httpClient: HttpClient, private messageService: MessageService) {}

	onHtmlInput(event: Event) {
		const html = (event.target as HTMLInputElement).innerHTML;
		this.logMessage = html;
	}

	public onSaveClick(): void {
		const historyNote = this.historyNotesService.selectedHistoryNote;
		this.messageService.publish(Events.savingPreloader, 1);
		this.handleExitClick.emit();

		this.httpClient
			.patch(`${environment.adminUrl}ClientHistoryNotes/${historyNote.Id}`, {
				LogSubject: historyNote.LogSubject,
				LogMessage: this.logMessage
			})
			.subscribe(() => {
				const index = this.historyNotesService.historyNotes.findIndex((note) => note.Id === historyNote.Id);

				if (index !== -1) {
					this.historyNotesService.historyNotes[index] = {
						...this.historyNotesService.historyNotes[index],
						LogSubject: historyNote.LogSubject,
						LogMessage: this.logMessage
					};
				}
				this.messageService.publish(Events.savingPreloader, 0);
			});
	}
}
